import { createFileRoute, redirect } from '@tanstack/react-router';
import { USER_ROLES } from 'cpool-constants';

import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { useUserStore } from '~/store/userStore';

export const Route = createFileRoute('/_app/management/division/')({
    beforeLoad: ({ location }) => {
        authoriseUser([USER_ROLES.division_leader], location);
        const content = 'ROUTE_TITLE.DIVISION_MANAGEMENT';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    loader: async ({ location }) => {
        const { user } = useUserStore.getState();
        if (!user) {
            throw redirect({ search: { redirect: location.href }, to: '/login' });
        }
    },
});
